import DataServiceSQL from "../DataService/DataServiceSQL.js";


const convert_fhir_format = (data, serial_Number, type) => {
  let results_tab = []
  let i = 0
  let result

  // TMP : silly to covert whereas it will be reconverted afterward
  while (data.component[i]) {

    // CASE BUNDLE
    if (data.component[i].resourceType === "Bundle") {
      result = {type: "", eventDate: data.component[i].entry[0].value.valueDateTime}
      let j = 0;
      let value = []
      while (data.component[i].entry[j]) {
        let label = ""
        let new_value = {value: data.component[i].entry[j].value.valueQuantity.value}
        result.type += data.component[i].entry[j].code.coding[0].code + ','
        switch(data.component[i].entry[j].code.coding[0].code) {
          case '9279-1' :
            label = "respiratory_rate"
            break
          case '33456-5' :
            label = "respiratory_leak"
            break
          case '3151-8' :
            label = "oxygen_flow_rate"
            break
          case '2708-6' :
            label = "oxygen_saturation"
            break
          case '69988-4' :
            label = "niv_schedule"
            break
          case 'LP75328-2' :
            label = "oxi_schedule"
            break
        }
        new_value.label = label
        value.push(new_value)
        j++;
      }
      result.type = result.type.slice(0, -1)
      result.value = JSON.stringify(value)
      i++
    }

    // CASE OBSERVATION
    else {      
      result = { type: data.component[i].code.coding[0].code}
      switch(data.component[i].code.coding[0].code) {
        case '8310-5' :         // thermometer
        case '72282-7' :        // state
        case '8418512.6' :      // battery
        case '29463-7' :        // Scale
        case '72514-3' :        // Pain
        case '45698-1' :        // healthform
        case '72170-4' :        // photography
        case '69988-4' :        // niv_schedule
        case 'LP75328-2' :      // oxigen_therapy_schedule
        case '3151-8' :         // oxigen_flow_rate
        case '9279-1' :         // respiratory_rate
        case '33456-5' :        // respiratory_leak
        case '90562-0' :        // respiratory_ahi (AHI/IAH)
        case '33456-95' :       // respiratory_leak95 (leak 95th percentile)
          result.value= data.component[i].value.valueQuantity.value;
          result.eventDate= data.component[i].value.valueDateTime;
          i+=1
          break

        case '2708-6,8867-4' :   // PulseOx
          result.value= "S" + data.component[i].value.valueQuantity.value + "P" + data.component[i+1].value.valueQuantity.value;
          result.eventDate= data.component[i].value.valueDateTime;
          i+=2 
          break

        case '8460-6,8867-4' :   // blood pressure
          result.value= "S" + data.component[i].value.valueQuantity.value + "D" + data.component[i+1].value.valueQuantity.value + "P" + data.component[i+2].value.valueQuantity.value;
          result.eventDate= data.component[i].value.valueDateTime;
          i+=3
          break
        case '2708-6' :   // PulseOx
          result.value= "S" + data.component[i].value.valueQuantity.value + "P" + data.component[i+1].value.valueQuantity.value;
          result.eventDate= data.component[i].value.valueDateTime;
          i+=2
          break

        case '8460-6' :   // blood pressure
          result.value= "S" + data.component[i].value.valueQuantity.value + "D" + data.component[i+1].value.valueQuantity.value + "P" + data.component[i+2].value.valueQuantity.value;
          result.eventDate= data.component[i].value.valueDateTime;
          i+=3 
          break 
        case '82611-5' : // TMP "temperature_color", "state" 
          break              
        default:
          i+=1
          break
      }
    }
    results_tab.push(result)
  }

  let ret = {
    href: "api/fhir/Observation?patient=" + serial_Number + "&" + type,
    nextResults: data.nextResults,
    results: results_tab
  }

  return ret
};


//Function to retrieve pulse rate and SP02 data of a profile from Docaposte
const get_patient_generic_Data = async (local_id_patient, startDate, endDate, type) => {

    var completeData = [];
    var next_Results_Data = [];
    var nextResults = "";
    var index = 0;
    var splice_cpt = 0;

  	var get_data_request = await Retrieve_Patient_Data(local_id_patient, startDate.toISOString(), endDate.toISOString(), type, "");
    if((get_data_request !== undefined)&&(get_data_request.results !== undefined)){
      get_data_request.results.forEach(data => {
        completeData.push(data);
      })

      if(get_data_request.nextResults !== ""){
        nextResults = get_data_request.nextResults;
        while (nextResults !== ""){
          next_Results_Data = await Retrieve_Patient_Data(local_id_patient, startDate.toISOString(), endDate.toISOString(), type, nextResults);
          if(next_Results_Data !== undefined){
            next_Results_Data.results.forEach(data => {
              completeData.push(data);
            })
            nextResults = next_Results_Data.nextResults;
          }
          else{
            nextResults = "";
          }
        }     
      }
    }

  return(completeData);
};

const Retrieve_Patient_Data = async (local_id_patient, startDate, endDate, type, nextResults) => {
  return await DataServiceSQL.axios_get_observation_fhir(local_id_patient, startDate, endDate, type, nextResults)
      .then(response => {
        response = convert_fhir_format(response, local_id_patient, type)
      	return(response);
      })
      .catch(e => {
        console.log(e);
      });
};

const ProfileDataGetter = {
  get_patient_generic_Data
};

export default ProfileDataGetter;